<template>
  <div class="register row justify-content-center">
      <div class="col-md-6">
          <b-alert variant="danger" dismissible :show="showDismissableAlert" @dismissed="showDismissableAlert=false">
                  {{ alertContents }}
          </b-alert>
          <form v-on:submit.prevent="submit">
            <b-form-fieldset
                label="Lösenord"
                :state="errors.has('password:min') ? 'danger' : 'success'">
                <b-form-input type="password" v-model="password" name="password" v-validate:password.initial="'min:6|confirmed:confirm'" placeholder="Lösenord"></b-form-input>
            </b-form-fieldset>
            <b-form-fieldset
                label="Repetera lösenord"
                :state="errors.has('password:confirmed') ? 'danger' : 'success'">
                <b-form-input type="password" name="confirm" placeholder="Repetera lösenord"></b-form-input>
            </b-form-fieldset>
            <b-form-fieldset
                label="Yta">
                <b-form-select text-field="name" value-field="id" :value="user.workarea" :options="workareas" @input="value => setWorkarea(value)" class="mb-3">
                </b-form-select>
            </b-form-fieldset>
            <b-button
                :block="true"
                variant="primary"
                size="lg"
                type="submit">Uppdatera</b-button>
          </form>
      </div>
  </div>
</template>

<script>
// import Auth from '@/services/auth'
import { mapActions } from 'vuex'

export default {
    name: 'Login',
    data () {
        return {
            password: null,
            email: null,
            workarea: null,
            showDismissableAlert: false,
            alertContents: 'Vi kunde inte uppdatera dina uppgifter just nu. Försök igen senare.'
        }
    },
    computed: {
        user () {
            return this.$store.state.authentication.user
        },
        workareas () {
            return this.$store.state.workarea.workareas
        }
    },
    methods: {
        ...mapActions({
            update: 'auth_update'
        }),
        submit: function () {
            this.$validator.validateAll().then(() => {
                this.update({ user: this.user, password: this.password, email: this.email, workarea: this.workarea })
            })
        },
        setWorkarea: function (value) {
            this.workarea = value
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue